import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "q-pl-md q-gutter-sm" };
const _hoisted_2 = { class: "q-pa-md" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el");
    const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_checkbox = _resolveComponent("q-checkbox");
    const _component_q_field = _resolveComponent("q-field");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, null, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_breadcrumbs, {
                    class: "text-grey",
                    "active-color": "green"
                }, {
                    separator: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                            size: "1.5em",
                            name: "chevron_right",
                            color: "primary"
                        })
                    ]),
                    default: _withCtx(() => [
                        (!_ctx.$q.screen.lt.md)
                            ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, {
                                key: 0,
                                label: "利用規約の確認",
                                icon: "navigation"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("div", { class: "text-h4 text-bold text-green-7" }, "利用規約の確認", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", { innerHTML: _ctx.html }, null, 8, _hoisted_4)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_q_field, {
                                        borderless: _ctx.agree,
                                        error: !_ctx.agree,
                                        "error-message": _ctx.presenceMessage,
                                        color: _ctx.agree ? 'green-7' : ''
                                    }, {
                                        control: _withCtx(() => [
                                            _createVNode(_component_q_checkbox, {
                                                modelValue: _ctx.agree,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.agree) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "上記内容をすべて理解し、同意する。", -1))
                                        ]),
                                        _: 1
                                    }, 8, ["borderless", "error", "error-message", "color"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    size: "lg",
                                    label: "同意して進む",
                                    color: _ctx.agree ? 'green-7' : 'green-4',
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.onClick,
                                    disable: !_ctx.agree
                                }, null, 8, ["color", "onClick", "disable"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
